import { Component } from '@angular/core';
import { TrustStatusPipe } from '@shared/pipes/trustStatusPipe';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TrustStatus } from '@models/trusts/trusts-enums';

@Component({
  selector: 'app-ag-trust-status',
  standalone: true,
  imports: [
    TrustStatusPipe
  ],
  templateUrl: './ag-trust-status.component.html',
  styleUrl: './ag-trust-status.component.scss'
})
export class AgTrustStatusComponent implements ICellRendererAngularComp {
  status = 0;
  TrustStatus = TrustStatus;

  agInit(params: ICellRendererParams): void {
    this.status = params.value as number;
  }

  refresh(params: ICellRendererParams): boolean {
    this.status = params.value as number;
    return true;
  }
}

